import React from 'react';
import { useQuery } from '@apollo/client';
import { Container, Typography, CircularProgress } from '@mui/material';
import { GET_PURCHASE_HISTORY } from '../../../graphql/queries';
import PurchaseHistoryTable from './PurchaseHistoryTable';

const MyPurchaseHistory: React.FC = () => {
  const { loading, error, data } = useQuery(GET_PURCHASE_HISTORY, {
    variables: {
      dateRange: {
        start: '2024-01-01',
        end: '2024-12-31',
      },
    },
  });

  if (loading) return <CircularProgress data-testid="loading-spinner" />;
  if (error) return <p data-testid="error-message">Error: {error.message}</p>;

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Purchase History
      </Typography>
      <PurchaseHistoryTable orders={data.purchaseHistory} />
    </Container>
  );
};

export default MyPurchaseHistory;
